module.exports = __webpack_public_path__ + "static/media/(000042).3277f75f.jpg";